/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicPaymentConfiguration = {
    paymentTypes: Array<'online' | 'cash' | 'invoice'>;
    onlinePaymentMethods: Array<'card' | 'sepa' | 'paypal' | 'klarna' | 'bank_transfer' | 'apple_pay' | 'google_pay'>;
    onlineProviderType?: PublicPaymentConfiguration.onlineProviderType | null;
    stripeConnectedAccountId?: string | null;
    stripePublishableKey?: string | null;
};
export namespace PublicPaymentConfiguration {
    export enum onlineProviderType {
        PAYPAL = 'paypal',
        STRIPE = 'stripe',
    }
}

